// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type EditBidLineItemMutationVariables = Types.Exact<{
  input: Types.SaveBidContractLineItemInput;
}>;


export type EditBidLineItemMutation = { __typename?: 'Mutation', saveBidContractLineItem: { __typename?: 'SaveBidContractLineItemResult', bidContractLineItem: { __typename?: 'BidContractLineItem', id: string, isTaxExempt: boolean, totalCostInCents: number } } };

export type EditBidRightPane_SaveBidContractMutationVariables = Types.Exact<{
  input: Types.SaveBidContractInput;
}>;


export type EditBidRightPane_SaveBidContractMutation = { __typename?: 'Mutation', saveBidContract: { __typename?: 'SaveBidContractResult', bidContract: { __typename?: 'BidContract', id: string, currentRevision: { __typename?: 'BidContractRevision', id: string } } } };

export type EditBidRightPane_SaveBidContractRevisionMutationVariables = Types.Exact<{
  input: Types.SaveBidContractRevisionInput;
}>;


export type EditBidRightPane_SaveBidContractRevisionMutation = { __typename?: 'Mutation', saveBidContractRevision: { __typename?: 'SaveBidContractRevisionResult', bidContractRevision: { __typename?: 'BidContractRevision', id: string } } };


export const EditBidLineItemDocument = gql`
    mutation EditBidLineItem($input: SaveBidContractLineItemInput!) {
  saveBidContractLineItem(input: $input) {
    bidContractLineItem {
      id
      isTaxExempt
      totalCostInCents
    }
  }
}
    `;

/**
 * __useEditBidLineItemMutation__
 *
 * To run a mutation, you first call `useEditBidLineItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditBidLineItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editBidLineItemMutation, { data, loading, error }] = useEditBidLineItemMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditBidLineItemMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EditBidLineItemMutation, EditBidLineItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EditBidLineItemMutation, EditBidLineItemMutationVariables>(EditBidLineItemDocument, options);
      }
export type EditBidLineItemMutationHookResult = ReturnType<typeof useEditBidLineItemMutation>;
export type EditBidLineItemMutationResult = ApolloReactCommon.MutationResult<EditBidLineItemMutation>;
export const EditBidRightPane_SaveBidContractDocument = gql`
    mutation EditBidRightPane_SaveBidContract($input: SaveBidContractInput!) {
  saveBidContract(input: $input) {
    bidContract {
      id
      currentRevision {
        id
      }
    }
  }
}
    `;

/**
 * __useEditBidRightPane_SaveBidContractMutation__
 *
 * To run a mutation, you first call `useEditBidRightPane_SaveBidContractMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditBidRightPane_SaveBidContractMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editBidRightPaneSaveBidContractMutation, { data, loading, error }] = useEditBidRightPane_SaveBidContractMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditBidRightPane_SaveBidContractMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EditBidRightPane_SaveBidContractMutation, EditBidRightPane_SaveBidContractMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EditBidRightPane_SaveBidContractMutation, EditBidRightPane_SaveBidContractMutationVariables>(EditBidRightPane_SaveBidContractDocument, options);
      }
export type EditBidRightPane_SaveBidContractMutationHookResult = ReturnType<typeof useEditBidRightPane_SaveBidContractMutation>;
export type EditBidRightPane_SaveBidContractMutationResult = ApolloReactCommon.MutationResult<EditBidRightPane_SaveBidContractMutation>;
export const EditBidRightPane_SaveBidContractRevisionDocument = gql`
    mutation EditBidRightPane_SaveBidContractRevision($input: SaveBidContractRevisionInput!) {
  saveBidContractRevision(input: $input) {
    bidContractRevision {
      id
    }
  }
}
    `;

/**
 * __useEditBidRightPane_SaveBidContractRevisionMutation__
 *
 * To run a mutation, you first call `useEditBidRightPane_SaveBidContractRevisionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditBidRightPane_SaveBidContractRevisionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editBidRightPaneSaveBidContractRevisionMutation, { data, loading, error }] = useEditBidRightPane_SaveBidContractRevisionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEditBidRightPane_SaveBidContractRevisionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EditBidRightPane_SaveBidContractRevisionMutation, EditBidRightPane_SaveBidContractRevisionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EditBidRightPane_SaveBidContractRevisionMutation, EditBidRightPane_SaveBidContractRevisionMutationVariables>(EditBidRightPane_SaveBidContractRevisionDocument, options);
      }
export type EditBidRightPane_SaveBidContractRevisionMutationHookResult = ReturnType<typeof useEditBidRightPane_SaveBidContractRevisionMutation>;
export type EditBidRightPane_SaveBidContractRevisionMutationResult = ApolloReactCommon.MutationResult<EditBidRightPane_SaveBidContractRevisionMutation>;